import React from "react";
import MultiSelectField from "./MultiSelectField";

export default function SelectLangOrCert({ options, ...field }) {
  return <MultiSelectField {...field} creatable options={options} />;
}
